//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is
the property of 6over6 Ltd. and its licensors. Any use of the Software is
strictly prohibited unless an explicit license or permission is granted by
6over6 Ltd.
<template>
  <section class="go_title_section">
    <div class="go_title_1">
      {{ store.state.page.title }}
    </div>
    <div v-if="showSubtitle" class="go_sub_title_1">
      {{ store.state.page.subtitle }}
    </div>
  </section>
</template>

<script setup>
import { defineProps } from "vue";
import { useStore } from "vuex";
defineProps({ showSubtitle: { type: Boolean, default: true } });
const store = useStore();
</script>

<style lang="scss" scoped>
.go_title_section {
  text-align: center;
  font-weight: 700;
  font-size: 54.75px;
  line-height: 63px;
  width: 986px;

  .go_sub_title_1 {
    margin-top: 15px;
    font-weight: 300;
    font-size: 30px;
    line-height: 38px;
  }

  @include tablet {
    font-size: 42px;
    line-height: 48px;
  }

  @include mobile {
    font-size: 24px;
    line-height: 36px;
  }

  .go_sub_title_1 {
    @include mobile {
      font-weight: normal;
    }
  }
}
</style>
